const useStyles = () => {
    return {
        tabContainer: {
            display: 'flex',
            gap: 2,
            alignItems: 'center',
            position: 'relative',
            width: '100%'
        },
        tabList: ({ justifyContent }:{justifyContent?: 'start' | 'end'}) => ({
            width: '100%',
            position: 'relative',
            borderBottom: 'none',
            '& .MuiTabs-indicator': {
                height: '0px'
            },
            '& .MuiTabs-flexContainer': {
                width: '100%',
                justifyContent: justifyContent ?? 'space-between',
                padding: '1px 2px 0px',
                '& .Mui-selected': {
                    color: 'primary.100',
                    fontWeight: 'bold',
                    background: 'white',
                    '-webkit-box-shadow': '0px -3px 8px -4px rgba(0,0,0,0.57)',
                    '-moz-box-shadow': '0px -3px 8px -4px rgba(0,0,0,0.57)',
                    'box- shadow': '0px -3px 8px -4px rgba(0,0,0,0.57)',
                }
            }
        }),
    }
}

export { useStyles }
